import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { isValidTenant } from './constants/tenant';
import { msalInstance, runWithMsal } from './authConfig';
import { MsalProvider } from '@azure/msal-react';
import { InvalidAccess } from './components/common/InvalidAccess';

const root = ReactDOM.createRoot(document.getElementById('root'));
 
runWithMsal(msalInstance, ()=>{
	const profile = msalInstance.getAllAccounts()[0];
	const { idTokenClaims } = profile;
	const { tid } = idTokenClaims;	
  
	if(isValidTenant({tid})){
		localStorage.setItem('user_profile', JSON.stringify(profile));
		root.render(
        <BrowserRouter>
        <MsalProvider instance={msalInstance}>
        	<App />
        </MsalProvider>
        </BrowserRouter>
    );
	}
	else {
		root.render(<InvalidAccess level='tenant'/>)
		
	}
})
